<template>
  <button class="btn"
          :class="{
            'btn-primary': currentValue === buttonValue,
            'btn-secondary': currentValue !== buttonValue
          }"
          @click="onClick(buttonValue)">
    {{ text ? text : buttonValue }}
  </button>
</template>

<script>
  export default {
    props: {
      buttonValue: [String, Number],
      currentValue: [String, Number],
      onClick: Function,
      text: String
    }
  }
</script>
